import {InjectionToken} from "@angular/core";
import type {IRootScopeService} from "angular";

/** Definerer metoder fra ajs {@link IRootScopeService} som vi benytter i ng2-koden */
export interface AjsRootScopeService extends Pick<IRootScopeService, '$on' | '$broadcast' | '$applyAsync' | '$evalAsync' | '$apply'> {
}

export const ajs_$rootScope_DI_TOKEN = new InjectionToken<AjsRootScopeService>('ajs $rootScope');
